module.exports = __webpack_public_path__ + "static/media/z1.f50c78b5.JPG";